<template>
  <div id="wizardCard" class="card card-wizard">
    <div class="vue-form-wizard md">
      <div class="content">
        <div class="container">
          <div class="row">
            <legend>Licencias </legend>
          </div>
          <div v-if="add_item">
            <div class="row">
              <div class="form-group col-md-6">
                <label class="control-label">Seleccione el movimiento a realizar</label>
                <el-select clearable class="select-default" filterable placeholder="Selecciona una opción" v-model="selects.simple">
                  <el-option v-for="option in selects.movimientos" class="select-default" :value="option.value" :label="option.label" :key="option.label">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div v-if="selects.simple ==1">
              <div class="row">
                <legend>Seguro que desea desactivar este registro?</legend>
                <div class="form-group col-md-12">
                  <label class="control-label">Observaciones</label>
                  <textarea class="form-control" type="text" placeholder="Motivos/Observaciones"></textarea>
                </div>
              </div>
            </div>
            <div v-if="selects.simple ==2">
              <div class="row">
                <legend>Crear baja </legend>
                <div class="form-group col-md-6">
                  <label class="control-label">Fecha baja</label>
                  <div class="form-group">
                    <el-date-picker type="date" name="fecha_inicio" v-model="item_usuarios.fecha_inicio" value-format="dd-MM-yyyy" format="dd-MM-yyyy" placeholder="Seleccione fecha">
                    </el-date-picker>
                    <small class="text-danger" v-show="fecha_inicio.invalid">
                      {{ getError('fecha_inicio') }}
                    </small>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label class="control-label">Tipo de baja</label>
                  <el-select clearable filterable class="select-default" placeholder="Seleccione una opción" name="tipo_baja" v-validate="item_usuariosValidations.tipo_baja" v-model="item_usuarios.tipo_baja">
                    <el-option value="Normal"></el-option>
                    <el-option value="Defunción"></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div v-if="selects.simple == 3">
              <div class="row">
                <legend> Crear licencia</legend>
                <div class="form-group col-md-6">
                  <label class="control-label">Fecha de inicio</label>
                  <div class="form-group">
                    <el-date-picker type="date" name="inicia" v-validate="item_usuariosValidations.inicia" v-model="item_usuarios.inicia" value-format="dd-MM-yyyy" format="dd-MM-yyyy" placeholder="Seleccione fecha">
                    </el-date-picker>
                    <small class="text-danger" v-show="inicia.invalid">
                      {{ getError('inicia') }}
                    </small>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label class="control-label">Fecha de Termino</label>
                  <div class="form-group">
                    <el-date-picker type="date" name="termina" v-validate="item_usuariosValidations.termina" v-model="item_usuarios.termina" value-format="dd-MM-yyyy" format="dd-MM-yyyy" placeholder="Seleccione fecha">
                    </el-date-picker>
                    <small class="text-danger" v-show="termina.invalid">
                      {{ getError('termina') }}
                    </small>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label class="control-label">Tipo de Licencia</label>
                  <el-select clearable filterable class="select-default" placeholder="Seleccione una opción" name="tipo_lic" v-validate="item_usuarios.tipo_lic" v-model="item_usuarios.encargo.tipo_lic">
                    <el-option :value="null">Selecciona una opción</el-option>
                    <el-option value="1">Médica</el-option>
                    <el-option value="2">Trabajo</el-option>
                  </el-select><small class="text-danger" v-show="tipo_lic.invalid">
                    {{ getError('tipo_lic') }}
                  </small>
                </div>
                <div class="form-group col-md-12">
                  <label class="control-label">Observaciones</label>
                  <textarea class="form-control" type="text" name="observaciones" v-validate="item_usuariosValidations.observaciones" v-model="item_usuarios.observaciones" placeholder="Observaciones"></textarea><small class="text-danger" v-show="observaciones.invalid">
                    {{ getError('observaciones') }}
                  </small>
                </div>
              </div>
            </div>
            <div v-if="selects.simple == 4">
              <div class="row">
                <legend> Crear Promoción</legend>
              </div>
              <div class="row">
                <div class="form-group col-md-8">
                  <label class="control-label">Servidor público</label>
                  <input class="form-control" type="text" name="nombres" v-validate="item_usuariosValidations.nombres" v-model="fullName" placeholder="Servidor Público" readonly><small class="text-danger" v-show="nombres.invalid">
                    {{ getError('nombres') }}
                  </small>
                </div>
                <div class="form-group col-md-8">
                  <label class="control-label">Empleo, Cargo o Comisión</label>
                  <input class="form-control" type="text" name="empleo_cargo_comision" v-validate="item_usuariosValidations.empleo_cargo_comision" v-model="item_usuarios.encargo.empleo_cargo_comision" placeholder="Dirección"><small class="text-danger" v-show="empleo_cargo_comision.invalid">
                    {{ getError('empleo_cargo_comision') }}
                  </small>
                </div>
                <div class="form-group col-md-8">
                  <label class="control-label">Área de adscripción</label>
                  <input class="form-control" type="text" name="area_adscripcion" v-validate="item_usuariosValidations.area_adscripcion" v-model="item_usuarios.encargo.area_adscripcion" placeholder="Área de adscripción"><small class="text-danger" v-show="area_adscripcion.invalid">
                    {{ getError('area_adscripcion') }}
                  </small>
                </div>
                <div class="form-group col-md-6">
                  <label class="control-label">Nivel del Encargo</label>
                  <input class="form-control" type="text" name="nivel" v-validate="item_usuariosValidations.nivel" v-model="item_usuarios.encargo.nivel_encargo" placeholder="Nivel tabular"><small class="text-danger" v-show="nivel.invalid">
                    {{ getError('nivel') }}
                  </small>
                </div>
              </div>
            </div>
            <div v-if="selects.simple == 5">
              <div class="row">
                <div class="form-group col-md-4">
                  <label class="control-label">RFC</label>
                  <input class="form-control" type="text" name="rfc" v-validate="item_usuariosValidations.rfc" v-model="item_usuarios.rfc" placeholder="RFC"><small class="text-danger" v-show="rfc.invalid">
                    {{ getError('rfc') }}
                  </small>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-4">
                  <label class="control-label">Nombre(s)</label>
                  <input class="form-control" type="text" name="nombres" v-validate="item_usuariosValidations.nombres" v-model="item_usuarios.nombres" placeholder="Nombre(s)"><small class="text-danger" v-show="nombres.invalid">
                    {{ getError('nombres') }}
                  </small>
                </div>
                <div class="form-group col-md-4">
                  <label class="control-label">Apellido Paterno</label>
                  <input class="form-control" type="text" name="primer_apellido" v-validate="item_usuariosValidations.primer_apellido" v-model="item_usuarios.primer_apellido" placeholder="Especificar"><small class="text-danger" v-show="primer_apellido.invalid">
                    {{ getError('primer_apellido') }}
                  </small>
                </div>
                <div class="form-group col-md-4">
                  <label class="control-label">Apellido Materno</label>
                  <input class="form-control" type="text" name="segundo_apellido" v-validate="item_usuariosValidations.segundo_apellido" v-model="item_usuarios.segundo_apellido" placeholder="Especificar"><small class="text-danger" v-show="segundo_apellido.invalid">
                    {{ getError('segundo_apellido') }}
                  </small>
                </div>
                <div class="form-group col-md-4">
                  <label class="control-label">Dependencia</label>
                  <el-select clearable filterable class="select-default" placeholder="Seleccione una opción" name="ente_publico_id" v-validate="item_usuariosValidations.ente_publico_id" v-model="item_usuarios.encargo.ente_publico_id">
                    <el-option v-for="option in dependencias" class="select-default" :value="option.id" :label="option.valor" :key="option.label"></el-option>
                  </el-select><small class="text-danger" v-show="ente_publico_id.invalid">
                    {{ getError('ente_publico_id') }}
                  </small>
                </div>
                <div class="form-group col-md-8">
                  <label class="control-label">Empleo, Cargo o Comisión</label>
                  <input class="form-control" type="text" name="direccion_cargo" v-validate="item_usuariosValidations.direccion_cargo" v-model="item_usuarios.encargo.empleo_cargo_comision" placeholder="Dirección"><small class="text-danger" v-show="direccion_cargo.invalid">
                    {{ getError('direccion_cargo') }}
                  </small>
                </div>
                <div class="form-group col-md-4">
                  <label class="control-label">Contrado por honorarios</label>
                  <el-select clearable filterable class="select-default" placeholder="Seleccione una opción" name="honorarios" v-validate="item_usuariosValidations.honorarios" v-model="item_usuarios.encargo.contratado_honorarios">
                    <el-option value="1">Si</el-option>
                    <el-option value="2">No</el-option>
                  </el-select><small class="text-danger" v-show="honorarios.invalid">
                    {{ getError('honorarios') }}
                  </small>
                </div>
                <div class="form-group col-md-4">
                  <label class="control-label">Nivel del Encargo</label>
                  <input class="form-control" type="text" name="nivel" v-validate="item_usuariosValidations.nivel" v-model="item_usuarios.encargo.nivel_encargo" placeholder="Nivel tabular"><small class="text-danger" v-show="nivel.invalid">
                    {{ getError('nivel') }}
                  </small>
                </div>
                <div class="form-group col-md-4">
                  <label class="control-label">Área de adscripción</label>
                  <input class="form-control" type="text" name="area_adscripcion" v-validate="item_usuariosValidations.area_adscripcion" v-model="item_usuarios.encargo.area_adscripcion" placeholder="Área de adscripción"><small class="text-danger" v-show="area_adscripcion.invalid">
                    {{ getError('area_adscripcion') }}
                  </small>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-12">
                  <label class="control-label">Motivo de corrección</label>
                  <textarea class="form-control" type="text" placeholder="Área de adscripción"></textarea>
                </div>
              </div>
            </div>
            <div v-if="selects.simple == 6">
              <div class="row">
                <legend> Modificar contraseña</legend>
                <div class="form-group col-md-6">
                  <label class="control-label">Contraseña</label>
                  <input class="form-control" type="password" name="Password" ref="Password" v-validate="item_usuariosValidations.Password" v-model="item_usuarios.password" placeholder="*****"><small class="text-danger" v-show="Password.invalid">
                    {{ getError('Password') }}
                  </small>
                </div>
                <div class="form-group col-md-6">
                  <label class="control-label">Confirmar contraseña</label>
                  <input class="form-control" type="password" name="Confirmar" v-validate="'required|confirmed:Password'" v-model="item_usuarios.Confirmar" placeholder="*****"><small class="text-danger" v-show="Confirmar.invalid">
                    {{ getError('Confirmar') }}
                  </small>
                </div>
              </div>
            </div>
            <div class="row justify-content-end m-3">
              <button class="btn btn-primary" @click.prevent="addItem()">
                <span v-if="edit_item == null">
                  <i class="fa fa-plus"></i> Agregar
                </span>
                <span v-else>
                  <i class="fa fa-save"></i> Guardar
                </span>
              </button>
              <button class="btn btn-danger ml-3" @click.prevent="cancelEdit()">
                <span>
                  <i class="fa fa-times"></i> Cancelar
                </span>
              </button>
            </div>
            <div class="row">
              <hr class="col-md-12 bg-info">
            </div>
          </div>
          <div v-if="!add_item">
            <div class="row">
              <div class="col-sm-6 col-md-6 col-lg-6">
              </div>
              <div class="col-sm-6 col-md-6 col-lg-6 pull-right">
                <b-form-group label-cols-sm="3" class="mb-0">
                  <b-input-group>
                    <b-form-input type="search" v-model="filter" placeholder="Buscar"></b-form-input>
                  </b-input-group>
                </b-form-group>
              </div>
            </div>
            <div class="row mt-3 mb-4">
              <div class="col-sm-12 col-md-12 col-lg-12">
                <v-data-table :headers="headers" :items="list_usuarios" :search="filter" :items-per-page="5" class="" :fixed-header="true">
                  <template v-slot:item.acciones="{ item }">
                    <div class="d-flex justify-content-center">
                      <b-button @click.prevent="editItem(item)" class="btn-s edit mr-2" variant="success" :disabled="edit_item != null">
                        <i class="fas fa-pencil-alt"></i></b-button>
                      <br>
                      <!--  <b-button @click.prevent="removeItem(item)" class="btn-s delete" variant="danger">
                        <i class="fas fa-times"></i></b-button> -->
                    </div>
                  </template>
                  <template v-slot:item.rfc="{ item }">
                    <div>{{item.usuarios.rfc}} </div>
                  </template>
                  <template v-slot:item.nombres="{ item }">
                    <div>{{item.usuarios.nombres + ' '+ item.usuarios.primer_apellido +' '+item.usuarios.segundo_apellido}} </div>
                  </template>
                  <!-- <template v-slot:item.ente="{ item }">
                    <div>{{item.ente.valor}}</div>
                  </template> -->
                  <template v-slot:item.area="{ item }">
                    <div>{{item.encargo.area_adscripcion}}</div>
                  </template>
                  <template v-slot:item.inicia="{ item }">
                    <div>{{item.inicia | dateFormat }}</div>
                  </template>
                  <template v-slot:item.termina="{ item }">
                    <div>{{item.termina | dateFormat }}</div>
                  </template>
                </v-data-table>
                <!-- <b-table id="tbl_licencias" responsive hover :items="list_usuarios" :fields="fields_list" :per-page="perPage" :current-page="currentPage" show-empty :filter="filter">

                  <template slot="acciones" slot-scope="row" class="actions">
                    <b-button size="sm" @click.prevent="editItem(row)" class="edit mr-2" :disabled="edit_item != null">
                      <i class="ti-pencil"></i>
                    </b-button>

                  </template>
                  <template slot="empty">
                    <h5>No existen registros</h5>
                  </template>
                  <template slot="tipo_id" slot-scope="row">
                    {{getTipoUsuarios(row.item.tipo_id)}}</template>
                  <template slot="ID_Dependencia" slot-scope="row">
                    {{getDependencias(row.item.ID_Dependencia)}}</template>
                  <template slot="usuarios.nombres usuarios.primer_apellido usuarios.segundo_apellido" slot-scope="row">
                    {{row.item.usuarios.nombres}} {{row.item.usuarios.primer_apellido}} {{row.item.usuarios.segundo_apellido}}</template>
                </b-table> -->
              </div>
              <!-- <div class="col-mb-12">
                <b-col md="6" class="my-1">
                  <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" first-text="<<" prev-text="<" next-text=">" last-text=">>" aria-controls="tbl_licencias"></b-pagination>
                </b-col>
              </div>
              <div class="col-mb-12 col-12">
                <p class="category">Mostrando <b>{{from + 1}}</b> a <b>{{to}}</b> de <b>{{total}}</b> registros</p>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from "vue";
  import moment from 'moment'
  import {
    Select,
    Option,
    DatePicker
  } from "element-ui";

  import {
    mapFields
  } from "vee-validate";

  import Domicilio from "../Domicilio.vue";

  Vue.use(Select);
  Vue.use(Option);
  export default {
    components: {
      [DatePicker.name]: DatePicker
    },
    props: ["data"],
    data() {
      return {
        options: [{
            id: 1,
            label: "foo"
          },
          {
            id: 3,
            label: "bar"
          },
          {
            id: 2,
            label: "baz"
          }
        ],
        filter: null,

        currentPage: 1,
        perPage: 50,
        rol: "",
        rows: null,
        id: 1,
        add_item: false,
        edit_item: null,
        tipos: null,
        n_domicilio: null,
        dependencias: null,
        item_usuarios: {},
        list_usuarios: [],
        item_usuariosValidations: {
          rfc: {
            required: true
          },
          nombres: {
            required: true
          },
          primer_apellido: {
            required: true
          },
          segundo_apellido: {
            required: true
          },
          ente_publico_id: {
            required: true
          },
          direccion_cargo: {
            required: true
          },
          nivel: {
            required: true
          },
          area_adscripcion: {
            required: true
          },
          honorarios: {
            required: true
          },
          AG172: {
            required: true
          },
          fecha_inicio: {
            required: true
          },
          tipo_baja: {
            required: true
          },
          termina: {
            required: true
          },
          inicia: {
            required: true
          },
          tipo_lic: {
            required: true
          },
          observaciones: {
            required: true
          },
          empleo_cargo_comision: {
            required: true
          }
        },
        headers: [{
            text: 'RFC',
            value: 'rfc',
            align: 'center',
          }, {
            text: 'Nombre',
            value: 'nombres',
            align: 'center',
          },
          /* {
                   text: 'Dependencia',
                   value: 'ente',
                   align: 'center',
                 },  */
          {
            text: 'Área',
            value: 'area',
            align: 'center',
          }, {
            text: 'Tipo de Licencia',
            value: 'tipo_licencia',
            align: 'center',
          }, {
            text: 'Motivo',
            value: 'motivo',
            align: 'center',
          }, {
            text: 'Inicio',
            value: 'inicia',
            align: 'center',
          },, {
            text: 'Termino',
            value: 'termina',
            align: 'center',
          },
        ],
        fields_list: [{
            key: "usuarios.rfc",
            label: "RFC",
            thClass: "td-medium",
            tdClass: "text-center td-medium",
            formatter: "emptyFields"
          },
          {
            key: "usuarios.nombres usuarios.primer_apellido usuarios.segundo_apellido",
            label: "Nombre",
            tdClass: "text-left",
            formatter: "emptyFields"
          },
          {
            key: "encargo.area_adscripcion",
            label: "Área",
            tdClass: "text-left",
            formatter: "emptyFields"
          },
          {
            key: "tipo_licencia",
            label: "Tipo de Licencia",
            thClass: "td-medium",
            tdClass: "text-left td-medium",
            formatter: "empty-fields"
          },
          {
            key: "motivo",
            label: "Motivo ",
            tdClass: "text-left",
            formatter: "empty-fields"
          },
          {
            key: "inicia",
            label: "Inicio",
            thClass: "td-small",
            tdClass: "text-center td-small",
            formatter: value => {
              if (value)
                return moment(String(value)).format('DD/MM/YYYY')
              else
                return ''
            }
          },
          {
            key: "termina",
            label: "Fin",
            thClass: "td-small",
            tdClass: "text-center td-small",
            formatter: value => {
              if (value)
                return moment(String(value)).format('DD/MM/YYYY')
              else
                return ''
            }
          }
        ],
        selects: {
          simple: "",
          movimientos: [{
              value: "1",
              label: "Desactivar servidor"
            },
            {
              value: "2",
              label: "Crear baja "
            },
            {
              value: "3",
              label: "Crear licencia"
            },
            {
              value: "4",
              label: "Crear promoción"
            },
            {
              value: "5",
              label: "Realizar corrección"
            },
            {
              value: "6",
              label: "Cambiar contraseña"
            }
          ]
        }
      };
    },
    computed: {
      ...mapFields([
        "rfc",
        "nombres",
        "primer_apellido",
        "segundo_apellido",
        "ente_publico_id",
        "direccion_cargo",
        "nivel",
        "area_adscripcion",
        "honorarios",
        "AG172",
        "Password",
        "Confirmar",
        "fecha_inicio",
        "tipo_baja",
        "termina",
        "inicia",
        "tipo_lic",
        "observaciones",
        "empleo_cargo_comision"
      ]),
      to() {
        let highBound = this.from + this.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },
      from() {
        return this.perPage * (this.currentPage - 1);
      },
      total() {
        //console.log(this.list_usuarios.length);
        this.rows = this.list_usuarios.length;

        return this.list_usuarios.length;
      },
      fullName: {
        get() {
          return `${this.item_usuarios.nombres} ${
          this.item_usuarios.primer_apellido
        } ${this.item_usuarios.segundo_apellido}`;
        },
        set(newValue) {
          const m = newValue.match(/(\S*)\s+(.*)/);

          this.nombres = m[1];
          this.primer_apellido = m[2];
          this.segundo_apellido = m[3];
        }
      }
    },
    methods: {
      initItem() {
        this.item_usuarios = {
          acciones: "",
          nombres: "",
          Paterno: "",
          Materno: "",
          User: "",
          Password: ""
        };
      },
      showItem() {
        this.add_item = !this.add_item;
      },
      cancelEdit() {
        if (this.edit_item) {
          this.edit_item.item._rowVariant = "";
        }
        this.initItem();
        this.showItem();
        this.edit_item = null;
      },
      addItem() {
        this.$validator.validateAll().then(response => {
          if (response) {
            if (this.item_usuarios) {
              this.loadButton(this.$refs.btnSave);
              this.$http.post("usuarios", this.item_usuarios).then(
                response => {
                  this.StepOk("Guardado");
                  if (this.edit_item === undefined || this.edit_item === null) {
                    this.list_usuarios.push({
                      ...response.data.usuario
                    });
                  } else {
                    this.list_usuarios.splice(
                      this.edit_item.index,
                      1,
                      this.item_usuarios
                    );
                    this.edit_item.item._rowVariant = "";
                  }
                  this.initItem();
                  this.showItem();
                  this.edit_item = null;
                },
                error => {
                  this.StepError(error);
                  //this.change =  true;
                }
              );
            }
          } else {
            this.StepW("Hay campos sin completar");
          }
        });
        //console.log(this.item_empresas);
      },
      editItem(indice) {
        this.showItem();
        this.edit_item = indice;
        this.item_usuarios = {
          ...this.list_usuarios[this.edit_item.index]
        };
        this.edit_item.item._rowVariant = "danger";
        $(".main-panel").animate({
            scrollTop: 100
          },
          500,
          "swing"
        );
      },
      removeItem(indice) {
        if (this.list_usuarios[indice].id !== null) {
          let item = this.list_usuarios[indice];
          this.list_usuarios.splice(indice, 1);
          this.Ask("Desea borrar este registro", () => {
            this.$http.delete("usuarios/" + item.id).then(
              response => {
                /* eventBus.$emit("Empresas", item); */
                this.list_usuarios.splice(indice, 1);
              },
              error => {
                this.Err(error);
              }
            );
          });
        }
      },
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      getDependencias(index) {
        var resp = " ";
        if (this.dependencias) {
          this.dependencias.forEach(function (item) {
            if (item.id == index) {
              resp = item.valor;
              return resp;
            }
          });
        }
        return resp;
      }
    },
    created() {
      this.initItem();
      this.rol = this.getKey("role");
      if (this.rol == 4) {
        this.filtro = this.getKey("ente_publico_id");
        // this.$http.get("infpersonal/usuarios/" + this.filtro).then(
        //   response => {
        //     this.list_usuarios = response.data.usuarios;
        //     this.filtro_usuarios = this.list_usuarios;
        //     //console.log(this.currentPage);
        //   },
        //   error => {
        //     this.Err(error);
        //   }
        // );
      }

      this.$http.get("servidores").then(
        response => {
          this.list_usuarios = response.data.usuarios;
          //console.log(this.list_usuarios);
        },
        error => {
          this.Err(error);
        }
      );
      this.$http.get("cat_ente_publico").then(
        response => {
          this.dependencias = response.data.entes_publicos;
        },
        error => {
          this.Err(error);
        }
      );
    }
  };

</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Formularios/Movimientos/Licencias.vue